import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HelpersService } from 'src/app/shared/services/helpers.service';

@Component({
  selector: 'app-error-general',
  templateUrl: './error-general.component.html',
  styleUrls: ['./error-general.component.scss']
})
export class ErrorGeneralComponent implements OnInit {
  public statusCode: string = '';

  constructor(private activatedRoute: ActivatedRoute,
              public helpersService: HelpersService) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params: any) => {
      this.statusCode = params.statusCode;
    })
  }

}
